<template>
  <div
    class="bg-static-brand-hi text-caption-bold flex items-center justify-center"
  >
    <IconTruckExpress />
    <div class="pl-8">
      {{ i18n(translations.label) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconTruckExpress } from '@ds/icons/IconTruckExpress'

import translations from './FreeShippingBanner.translations'

const i18n = useI18n()
</script>
